module.exports = __webpack_public_path__ + "static/img/accredited.99e12365.svg";